/**
 * 创建人：张丽莉
 * 时间：2019-8-16
 * 描述：打印表格 和 统计图
 * 使用说明: 
 * 更新记录:  
 */
import { Component,OnInit, Output, EventEmitter,ViewChild, Input, ElementRef} from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
declare var $: any;
@Component({
  selector: 'sw-table-print',
  templateUrl: './sw-table-print.component.html',
  styleUrls: ['./sw-table-print.component.css']
})
/**
 * 格式如下：
 * var title = [{descript: this.Data.name1,name: 'name'},{descript: this.Data.name2,name: 'value'}]
 * let param = {datasTitle: title, datas: this.Datas,headerLogo:"活动预约分析数据",printEcharts:'.graph',isHiddenEcharts:false}
 *  this.create.createModal(SwTablePrintComponent,param)
 * 
 * 说明：printEcharts、isHiddenEcharts可传可不传     
 * 1.printEcharts 当有特殊统计图时，可加id标识分辨  
 * 2.isHiddenEcharts 默认打印统计图片   当为true时,不打印统计图，只打印表格数据
*/
export class SwTablePrintComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent; //弹出层组件
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  // printCSS: string[];
  // printStyle: string;
  // printBtnBoolean = true;
  /**
   * headerLogo 预览表格弹框的标题 初始值为打印 参数可传，也可不传
   */
  headerLogo:string = "打印"; 
   /**
   * datasTitle 预览表格和打印表格的表头数据 如 [{descript: '文物类别',name: 'name'},{descript: '数量',name: 'count'}]
   * 
   */
  datasTitle:any = [];
    /**
   * datas 预览表格和打印表格的表格数据 如 [{name: '金银器',count: '0'},]
   * 
   */
  datas: any = [];
 
  printEcharts:any = '.graph' //打印统计图的对象   class名或id名  不传参时默认.show_graph  （可传可不传）
  echartsImg:any = '' ;////打印统计图的路径
  isHiddenEcharts:boolean = false; //是否隐藏统计图片（可传可不传）  不传参时默认false,打印统计图
  constructor() {
    // this.printCSS = ['assets/Theme/default/bootstrap.min.css','assets/Theme/default/Main.All.css'];
    // this.printStyle =
    //   `
    //   th{
    //     background-color: #f5f5f7 !important;
    //  }
    //  `;
   }
   //打印完需要执行代码
  //  printComplete() {
  //    // this.printBtnBoolean = true;
  //   }
   
  //   beforePrint() {
     
  //    // this.printBtnBoolean = false;
  //   }
    
  ngOnInit() {
    if(this.param['headerLogo']) {
      this.headerLogo = this.param['headerLogo']
    }
     this.datasTitle = this.param['datasTitle'];
     this.datas = this.param['datas'];
     //判断是否打印统计图功能
     if(this.param['isHiddenEcharts']){
        this.isHiddenEcharts = true
     }else {
        //this.isHiddenEcharts = false
        //判断是否有传参对象
        if(this.param['printEcharts']){
          this.printEcharts = this.param['printEcharts']
        }
        var mycanvas = $(this.printEcharts).find("canvas")[0];
        var image = ''
        if(mycanvas){
          image = mycanvas.toDataURL("image/png");
        }
        this.echartsImg = image
     }
  }

  /**
   * 打印
   */
  printHtml() {
    let iframe = document.createElement('IFRAME');
    let doc = null;
    iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
    iframe.setAttribute('class', 'print-iframe');
    document.body.appendChild(iframe);
    doc = iframe['contentWindow'].document;
    let html = $("#gridContainer").html();
    doc.write('<div>' + html + '</div>');
    doc.close();
    iframe['contentWindow'].focus();
    iframe['contentWindow'].print();
    if (navigator.userAgent.indexOf("MSIE") > 0) {
        document.body.removeChild(iframe);
    }
  }
  /**
   * 取消
   */
  cancelCancel() {
    $("#body").find('.print-iframe').remove()
    this.callback.emit()
  }



}